import { Box, Card, Tabs } from '@mui/material';
import { FC, useState } from 'react';
import { useTranslate } from 'react-admin';

import { MuiTab } from '@sh4res/bo-common/components/Tab';

import { CompaniesEmployeesDistribution } from '@Resources/distributor/dashboard/CompaniesEmployeesDistribution';
import { OutstandingBreakdown } from '@Resources/distributor/dashboard/OutstandingBreakdown';
import { OutstandingTimeline } from '@Resources/distributor/dashboard/OutstandingTimeline';

const tabs = ['standard', 'er'] as const;

export const DistributorDashboard: FC = () => {
  const [tab, setTab] = useState<'standard' | 'er'>('standard');
  const translate = useTranslate();

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTab(tabs[newValue]);
  };

  return (
    <Box sx={{ padding: '5px' }}>
      <Card sx={{ overflow: 'visible', padding: '5px' }}>
        <Tabs value={tabs.indexOf(tab)} onChange={handleChange}>
          <MuiTab label={translate('resources.distributor.dashboard.tabs.standard')} />
          <MuiTab label={translate('resources.distributor.dashboard.tabs.er')} />
        </Tabs>

        <OutstandingTimeline source={tab} />
        {tab === 'standard' && <CompaniesEmployeesDistribution />}
        <OutstandingBreakdown source={tab} />
      </Card>
    </Box>
  );
};
